import { Group, Text } from '@mantine/core';

import { useTranslation } from 'react-i18next';

import type { FindOneVaultSearchResponseDTO } from '../../../../../shared/api/magellan/vaultSearch/dto';
import { TextSeparator } from '../../../../../shared/components/TextSeparator';

export function VaultSearchResultTitle({
  searchData,
}: {
  searchData: FindOneVaultSearchResponseDTO;
}) {
  const { t } = useTranslation('bidResponse');

  const numberOfDocuments = searchData?.results.length;

  const numberOfChunks = searchData?.results.reduce(
    (acc, result) => acc + result.chunks.length,
    0,
  );

  return (
    <Group noWrap spacing="01">
      <Text size="md" c="gray.9" fw={500}>
        {t('project.title')}
      </Text>
      <TextSeparator />
      <Text variant="sm" fw={400} c="gray.6">
        {t('search.results.documentsCount', {
          count: numberOfDocuments,
        })}
      </Text>
      <TextSeparator />
      <Text variant="sm" fw={400} c="gray.6">
        {t('search.results.chunksCount', {
          count: numberOfChunks,
        })}
      </Text>
    </Group>
  );
}
